import styled from 'styled-components';

export const PersonalFundraisersSection = styled.section`
            
`; 

export const FundraiserTitle = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif; 
    font-size:40px; 
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 30px;  

    @media screen and (max-width:1199px) {
        font-size: 35px;
        line-height: 40px;
    }

    @media screen and (max-width:991px) {
        font-size: 30px;
        line-height: 35px;
    }

    @media screen and (max-width:575px) {
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 20px;
    }

`;
export const PersonalFundraisersBox = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 20px;
    margin-bottom: 20px;
`;

export const ImageBox = styled.div`
    border-radius: 20px;
    position: relative;
         display: block;
    padding-bottom: 61.5%;
    position: relative;
    border-radius: 15px;
    overflow: hidden;
    img{
        border-radius: 20px;
       width: 100%;
        height: 100%;
        object-fit: cover;
        transform: scale(1);
        transition: all .5s ease;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    &:after{
        background: transparent linear-gradient(180deg, #00000000 0%, #000000 100%) 0% 0% no-repeat padding-box;
        border-radius: 20px;
        position: absolute;
        width: 100%;
        height: 100%;
        content: "";
        left: 0;
        z-index: 1;
        opacity: 0.9;
    }   
`;

export const ContentBox = styled.div`
    padding:15px 20px;
    .ant-tooltip-content {
      position: relative;
      top:20px;
}
`;

export const ContentTitle = styled.h3`
    color: #33A7AE;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 600;
    line-height: 27px;
    margin-bottom: 15px;

    @media screen and (max-width:991px) { 
        font-size:16px;
        line-height: 24px;
    }

    @media screen and (max-width:575px) { 
        font-size:14px;
        line-height: 22px;
    }
`;

export const FundraiserButton = styled.div`
 display: flex;
    gap: 20px;
    button{
        padding: 12px 9px !important;
        
        @media screen and (max-width:1199px) { 
            padding: 12px 30px;
            width: 100%;
        }
   }
`;

export const FundraisersName = styled.div`
    position: absolute;
    bottom: 10px;
    display: flex;
    align-items: center;
    gap:10px;
    left: 10px;
    z-index: 2;
`;
export const ImageCol = styled.div`
    width:36px;
    height:36px;
    min-width:36px;
    img{
       width:36px;
    height:36px;
    min-width:36px;
     }
`;

export const Name = styled.span`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 600;
    line-height:21px;
`;

export const MarketCare = styled.div`
   
`;

export const MarketChildCare = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:20px;
`;

export const MarketChildList = styled.ul`
    padding: 0;
    margin: 0 ;
    list-style: none;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    position: relative;

    @media screen and (max-width:991px) { 
        align-items: center;
    }

    &:after{
        background: #33A7AE80;
        width: 100%;
        height: 2px;
        content: "";
        bottom: 85px;
        position: absolute;
        @media screen and (max-width:991px) { 
            bottom: 0;
            top: 0;
            margin: auto;
        }
        @media screen and (max-width:767px) { 
            display: none;
        }
    }
`;

export const MarketChildTitle = styled.h4`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 600;
    line-height: 27px;
    margin-bottom: 0px;    
`;
export const MarketChildNumber = styled.span`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 600;
    line-height: 27px;
    margin-bottom: 0px;
`;
export const MarketChildItem = styled.li`
    width: calc(33.33% - 10px);
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: flex;
    padding: 20px 183px 20px  30px;
    gap: 10px;
    margin-bottom:40px;

    @media screen and (max-width:1199px) { 
        padding:20px;
    }

    @media screen and (max-width:991px) { 
        padding: 11px 20px;
        margin-bottom: 20px;
    }

    @media screen and (max-width:575px) { 
        width:100%;
        padding: 16px 28px;
        margin-bottom: 20px;
    }

    &:nth-child(2) {
        background: #F9DC70;
        padding: 20px 93px 20px  30px;
        @media screen and (max-width:1199px) { 
            padding:20px;
        }
        @media screen and (max-width:991px) { 
            padding:11px 16px;
        }
        @media screen and (max-width:575px) { 
            padding:20px;
        }
        ${MarketChildTitle}{
            color:#333;
        }
        ${MarketChildNumber}{
            color:#333;
        }

    }

    &:nth-child(3) {
        background: #FFD495;
        padding: 20px 142px 20px  30px;
        @media screen and (max-width:1199px) { 
            padding:20px;
        }
        @media screen and (max-width:991px) { 
               padding:11px 16px;
        }
        @media screen and (max-width:575px) { 
            padding:20px;
        }
        ${MarketChildTitle}{
            color:#333;
        }
        ${MarketChildNumber}{
            color:#333;
        }
     }

     &:nth-child(4) {
        background: #D3D3D3;
        padding: 20px 80px 20px  30px;
        margin-bottom:0px;
        @media screen and (max-width:1199px) { 
            padding:20px;
        }
        @media screen and (max-width:991px) { 
            padding:16px;
        }
        @media screen and (max-width:575px) { 
            padding:20px;
            margin-bottom:20px;
        }
        ${MarketChildTitle}{
            color:#333;
        }
        ${MarketChildNumber}{
            color:#333;
        }
     }

     &:nth-child(5) {
        background: #D3D3D3;
        padding: 20px 80px 20px  30px;
        margin-bottom:0px;
        @media screen and (max-width:1199px) { 
            padding:20px;
        }
        @media screen and (max-width:991px) { 
            padding:16px;
        }
        @media screen and (max-width:575px) { 
            padding:20px;
        }
        ${MarketChildTitle}{
            color:#333;
        }
        ${MarketChildNumber}{
            color:#333;
        }
     }
`;

export const SocialMediaSection = styled.div`
    margin-top:30px;
    margin-bottom:50px;
`;

export const SocialMediaLabel = styled.h5`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 500;
    line-height: 19px;
    margin-bottom: 0px;
`;

export const SocialMediaList = styled.ul`
    padding: 0;
    margin: 0 ;
    list-style: none;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @media screen and (max-width:991px) { 
        gap:10px;
    }
`;

export const SocialMediaItem = styled.li`
    width: calc(25.33% - 10px);
    background: #4267B2 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    gap: 10px;
    cursor:pointer;
    align-items: center;
    padding: 12px 0px;
.view-fundraiser{
  width:100%;
}
    @media screen and (max-width:991px) {
        width: calc(33.33% - 10px);
      
    }

    @media screen and (max-width:575px) { 
        width:100%;
    } 

    .btn-outline-success-blue{
        padding: 12px 84px;

        @media screen and (max-width:1199px) { 
            padding: 12px 50px;
                  width: 100%;

        }
    }

    &:nth-child(2)  {
        background:#000000;
    }

    &:nth-child(3)  {
        background:#F7931E;
        ${SocialMediaLabel}{
            color:#333333; 
        }
        img{
            filter: invert(1);
        }
    }

    &:last-child{
        background:none;
        padding: 0;
        @media screen and (max-width:991px) {
          gap:0;
          justify-content: flex-start;
          width: 100%;
        }
    }

`;


export const SocialMediaIcon = styled.span`
   display: flex;
`;


export const  PersonalFundraisersTable = styled.div`
    .table-section{
        background: transparent;
    } 
`;


export const  TableButton = styled.div`
    display: flex;
    gap: 15px;
    @media screen and (max-width:1199px) {
         margin-bottom:20px;
     }   

    @media screen and (max-width:480px){
        flex-direction: column;
    }

    .btn-border{
        box-shadow: 3px 5px 20px #00000033;
        border: 1px solid #01606F;
        border-radius: 10px;
        background: #fff;
        color: #01606F;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 23px;
        margin-bottom: 0;
        padding: 12px 30px;

        &:hover{
            background:#FFD495;
            color:#333333;
            border: 1px solid #FFD495;
        }

        @media screen and (max-width:575px) {
            padding: 12px 10px;
        }
    }
    .btn-outline-success-blue{
        padding: 12px 36px;
        @media screen and (max-width:575px) {
            padding: 12px 10px;
        }
    }
`;


export const  PersonalFundraisersEdit = styled.div`
   .btn-outline-success-blue{
     padding: 12px 33px;
   }
`;

export const  SubTitle = styled.h3`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 500;
    line-height: 21px;
    margin-bottom: 30px;
`;



export const  FromSection = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 10px #0000000D;
    border-radius: 15px;
    padding:20px;
    margin-bottom: 30px;

    .upload-img{
        height: 220px;
        width: 384px;
        position: relative;
        z-index: 111;
        background-color: transparent;
        border: none;
        font-size:0;
        overflow: hidden;
        
        &::-webkit-file-upload-button {
            display: none;
        }
        @media screen and (max-width:575px) {
            height: 210px;
        }
        
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

    }
    .profile-upload{
        width:100%;
        max-width: 384px;
        max-height: 220px;
        display: flex;
        position: relative;
        margin-bottom: 20px;
        overflow: hidden;
        border-radius: 10px;
        &:hover{
            &:after {
                display: block;
            }
        }
        &:after {
            background: rgb(1 96 111 / 80%) 0% 0% no-repeat padding-box;
            width: 100%;
            height: 100%;
            content: "";
            top: 0;
            position: absolute;
            border-radius: 10px;
            display: none;
        }
        .add-photo{
            position: absolute;
            z-index: 1;
            text-align: center;
            left: 0;
            right: 0;
            top: 50%;
            color: #fff;
            font-family: "Jost", sans-serif;
            font-size: 16px;
            font-weight: 400;
            line-height: 23px;
            transform: translateY(-50%);
        }
    }

    .form-label {
        color: #333333;
        font-family: "Jost", sans-serif;
        font-size: 20px;
        font-weight: 600;
        line-height: 30px;
        margin-bottom: 10px;
    }
    .input-box{
        margin-bottom: 20px;
        .form-control {
            background: #F3F3F3 0% 0% no-repeat padding-box;
            border-radius: 10px;
            border: none;
            height:56px;
            margin-bottom: 20px;
            padding: 15px;
           &:last-child{
            margin-bottom: 0px;
           } 
        }
        textarea{
            height:237px !important;
        }
    }
    

`;

export const  ImageUpload = styled.div`
    width: 384px;
    min-width: 384px;
    position: absolute;
    overflow: hidden;
    border-radius: 10px;
    height: 100%;
    @media screen and (max-width:575px) { 
        width: 100%;
        min-width: inherit;
    } 
  img{
    width:100%;
    border-radius: 10px;
    @media screen and (max-width:575px) { 
        max-width:inherit;
    }
  }
`;


export const  FileIcon = styled.div`
 
`;

